import { render } from "./ManageBenchmarkExclusionList.vue?vue&type=template&id=dcbaa2d8"
import script from "./ManageBenchmarkExclusionList.vue?vue&type=script&lang=js"
export * from "./ManageBenchmarkExclusionList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__